import React from 'react'
import spaceShip from './imgs/logoFooter.png'
import { Main } from './styles'

export default function Footer() {
    return (
        <Main>
            <img src={spaceShip} alt="" />
        </Main>
    )
}